module.exports = __webpack_public_path__ + "img/SCN-vibrating-wire-linear-formula-12pt.c792f58a.svg";